import CONST from 'app/common/lib/Const';
import urlUtil from 'app/common/lib/urlUtil';

export const queryUtils = {};

queryUtils.constructQueryStatesParams = (queryStates, changedQueryState) => {
  let param = '';

  if (queryStates.length > 0) {
    const termMetas = queryStates.map((queryState) =>
      queryUtils.constructSingleQueryStateParam(queryState),
    );
    const queryParams = {
      term_meta: termMetas,
    };
    if (changedQueryState) {
      queryParams[changedQueryState.action] = queryUtils.constructSingleQueryStateParam(
        changedQueryState,
      );
    }
    param = '&' + urlUtil.getQueryStringFromObject(queryParams);
  }
  return param;
};

queryUtils.constructSingleQueryStateParam = (state) => {
  const { filter_type, index, term, type } = state;

  switch (type) {
    case 'typed':
    case 'hashtag':
    case 'typo_auto_original':
      return `${term}|${type}`;
    case 'recentsearch':
    case 'autocomplete':
    case 'trending':
      return `${term}|${type}|${index}`;
    case 'guide':
      return `${term}|${type}|${filter_type}|${index}`;
    default:
      break;
  }
  return undefined;
};

queryUtils.tokenizeQuery = (query) => {
  if (query) {
    const terms = query.split(/\s+/);
    const conjunction = terms.find((term) =>
      CONST.SEARCH_FILTER_CONJUNCTIONS.includes(term.toLowerCase()),
    );

    if (conjunction) {
      return [query];
    } else {
      return terms;
    }
  }
  return [];
};

export default queryUtils;
